import { CircularProgress, Paper, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import { useState, useEffect } from 'react';
import ArtApi from "../../api/ArtApi";
import { RouteComponentProps } from "react-router-dom";

import IUser, { ContactPreference } from "../../models/Users/IUser";
import UserRole from "../../components/Users/UserRoleView";
import EditUserField from "../../components/Users/EditUserField";
import { UserRoles } from "../../components/AuthDataProvider";

type UserProps = RouteComponentProps<{
    userId: string;
}>;

export const User = (props: UserProps) => {
    const [error, setError] = useState<string | null>(null);
    const [user, setUser] = useState<IUser | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        ArtApi.getUser(props.match.params.userId)
            .then(response => {
                setUser(response.response);
                setIsLoading(false);
            })
            .catch(error => {
                setError(error.message);
                setIsLoading(false);
            });
    }, [props.match.params.userId]);

    return (
        <Paper className="paper">
            {user? 
            <Table classes={{ root: "reactivetable" }}>
                <TableBody>
                <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>{user.userId}</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>{user.name}</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>E-Mail</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Slack ID</TableCell>
                        <TableCell>{user.slackId}</TableCell>
                        <TableCell><EditUserField
                            userId = {user.userId}
                            fieldKey = "slackId"
                            fieldValue = {user.slackId ? user.slackId : ""}
                            friendlyField = "Slack ID"
                            details = "Get your slack ID from User Picture -> View Full Profile -> More -> Copy member ID"
                            fieldType = "string"
                            updateUser = {(data: string) => setUser(prevState  => (prevState ? {...prevState, slackId: data}: null))}
                        />
                            </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Contact Preference</TableCell>
                        <TableCell>{user?.contactPreference}</TableCell>
                        <TableCell><EditUserField
                            userId = {user.userId}
                            fieldKey = "contactPreference"
                            fieldValue = {user.contactPreference}
                            friendlyField = "Contact Preference"
                            details = "'email' or 'slack'"
                            fieldType = "string"
                            updateUser = {(data: ContactPreference) => setUser(prevState  => (prevState ? {...prevState, contactPreference: data}: null))}
                        /></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Roles</TableCell>
                        <TableCell>{user?.roles.map((userRole, i) => (
                            <UserRole key={i} role={userRole} />
                        ))}</TableCell>
                        <TableCell><EditUserField
                            userId = {user.userId}
                            fieldKey = "roles"
                            fieldValue = {user.roles.toString()}
                            friendlyField = "User Roles"
                            details = "'admin', 'art', 'dataScience', 'reviewer'"
                            fieldType = "list"
                            updateUser = {(data: UserRoles[]) => setUser(prevState  => (prevState ? {...prevState, roles: data}: null))}
                        /></TableCell>
                    </TableRow>

                </TableBody>
            </Table>
            : null}
            {isLoading && <CircularProgress color="secondary" />}
            {error}

        </Paper>
    )
}